/* eslint-disable @next/next/no-img-element */
"use client";
import {
  Avatar,
  Box,
  Button,
  IconButton,
  InputAdornment,
  Rating,
  TextField,
} from "@mui/material";
import SocialLinks from "../socialLinks";
import { useRouter } from "next/navigation";

function Footer() {
  const router = useRouter()
  return (
    <>
      <footer className="site_footer">
        <div className="container">
          <div className="inner">
            <div className="col_single">
              <h3>Subscribe to Our Newsletter & Get Exclusive Offers</h3>
              <div className="form">
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="Enter Your Email Address"
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button>Subscribe</Button>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </div>
            <SocialLinks />
            </div>
            <div className="col_single">
              <h4>SHOP</h4>
              <ul>
                <li>
                  <Box component="a" onClick={()=> router.push('/product/product-category')}>Best Sellers</Box>
                </li>
                <li>
                  <Box component="a" onClick={()=> router.push('/product/product-category')}>Global+</Box>
                </li>
                <li>
                  <Box component="a" onClick={()=> router.push('/product/product-category')}>Local Shops</Box>
                </li>
                <li>
                  <Box component="a" onClick={()=> router.push('/product/product-category')}>New arrivals</Box>
                </li>
                <li>
                  <Box component="a" onClick={()=> router.push('/flash-sales')}>Flash Sales</Box>
                </li>
              </ul>
            </div>
            <div className="col_single">
              <h4>COMPANY</h4>
              <ul>
                <li>
                  <Box component="a" onClick={()=> router.push('/account/about-us')}>About us</Box>
                </li>
                <li>
                  <Box component="a" >Careers</Box>
                </li>
                <li>
                  <Box component="a">News & Media</Box>
                </li>
                <li>
                  <Box component="a">Affiliates & Creators</Box>
                </li>
                <li>
                  <Box component="a" >Feedback</Box>
                </li>
              </ul>
            </div>
            <div className="col_single">
              <h4>NEED HELPS</h4>
              <ul>
                <li>
                  <Box component="a">Contact Us</Box>
                </li>
                <li>
                  <Box component="a" onClick={()=>('/account/help-center')}>Help center</Box>
                </li>
                <li>
                  <Box component="a" onClick={()=> router.push('/account/orders/detail/?mode=Pending')}>Track Orders</Box>
                </li>
                <li>
                  <Box component="a" >Return</Box>
                </li>
              </ul>
            </div>
            <div className="col_single">
              <h4>
                {" "}
                <Avatar>W</Avatar> Download Womancart App
              </h4>
              <div className="scan_app">
                <figure>
                  <img src="/images/qr_code.svg" alt="qr code" />
                </figure>
                <div className="scan_cnt">
                  <h3>Scan to download</h3>
                  <Rating
                    name="all-filled"
                    value={5}
                    max={5}
                    size="small"
                    readOnly
                  />
                  <p>5.0 rating from 100K+ app users</p>
                </div>
              </div>
              <div className="btn_group">
                <IconButton>
                  <figure>
                    <img src="/images/app_store.png" alt="img" />
                  </figure>
                </IconButton>
                <IconButton>
                  <figure>
                    <img src="/images/play_store.png" alt="img" />
                  </figure>
                </IconButton>
              </div>
            </div>
          </div>
          <div className="we_accept">
            <h5>WE ACCEPT</h5>
            <figure>
              <img src="/images/payment_img.png" alt="img" />
            </figure>
          </div>
        </div>
        <div className="copywrite">
          <div className="container">
            <ul className="about_web">
              <li>
                <figure>
                  <img src="/images/global_icon.svg" alt="img" />
                </figure>
                United States
              </li>
              <li>English (US)</li>
              <li>₹ (Rupee)</li>
            </ul>
            <ul className="cms_pages">
              <li>
                <a>© 2025 Womancart, Inc</a>
              </li>
              <li>
                <a>Recall</a>
              </li>
              <li>
                <a >Term</a>
              </li>
              <li>
                <a onClick={()=> router.push('/privacy-policy')}>Privacy</a>
              </li>
              <li>
                <a >Community Rules</a>
              </li>
              <li>
                <a >Interest-based ads</a>
              </li>
              <li>
                <a >Regions</a>
              </li>
              <li>
                <a >Cookie settings</a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
